import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, of } from 'rxjs';
import { PropertyListingDto, MultiplePropertyListingDto, AdvertGeneratorDto, TaskListDto, UserDto, AdvertCreatorFiltersDto, AdvertGenerateStatusDto } from '../../../../../../app/services/property-matrixV2/models';
import { AdvertService, FileManagementService, PropertyListingService, UserManagementService } from '../../../../../../app/services/property-matrixV2/services';
import { ListingStateService } from '../../../../../../app/shared/services/listing-state-service/listing-state.service';
import { NotificationService } from '../../../../../../app/shared/services/notification-service/notification.service';

@Component({
  selector: 'app-advert-publish',
  templateUrl: './advert-publish.component.html',
  styleUrls: ['./advert-publish.component.scss', '../../../../../../css/2-modules/_admin-portal.scss']
})
export class AdvertPublishComponent implements OnInit {
  @Input() selectedListing: PropertyListingDto | undefined;
  @Input() selectedListingGroup: MultiplePropertyListingDto | undefined;
  @Input() isMultiple: boolean | undefined;
  @Input() sectorType: string | undefined;
  @Output() booleanEvent = new EventEmitter<boolean>();
  @Input() advertCreatorFiltersDto: AdvertCreatorFiltersDto = {}
  sections = [
    { key: 1, value: 'Advert for Developed Preview:', checked: true },
    { key: 2, value: 'Advert for Developable Preview:', checked: true },
  ];

  loading: boolean = false;
  advertGeneratorDeveloped: AdvertGeneratorDto | null = {};
  advertGeneratorDevelopable: AdvertGeneratorDto | null = {};
  advertStatusList: AdvertGenerateStatusDto[] = [];
  advertStatusFilteredList: AdvertGenerateStatusDto[] = [];
  currentUser: UserDto | undefined;
  listingType: string | undefined;
  showDevelopedOnly: boolean = false;
  showDevelopAbleOnly: boolean = false;
  developedImageFileUrl: string = "";
  developableImageFileUrl: string = "";
  developedIcons: any[] = [];
  developableIcons: any[] = [];

  legendItems = [
    { iconName: 'construction', iconPath: "assets/maps/legend/construction.png", text: 'UNFINISHED/INCOMPLETE STRUCTURES\nThis refers to the sale of property that includes incomplete structures or buildings. The property is sold "as-is", without any finished construction.' },
    { iconName: 'expand', iconPath: "assets/maps/legend/expansion.png", text: 'EXPANSION OPPORTUNITY\nThis refers to a property that offers potential for enlargement or development, either through new structures, the extension of existing ones, or the utilization of available land on the property for future construction.' },
    { iconName: 'whitebox', iconPath: "assets/maps/legend/whitebox.png", text: 'WHITE BOX\nThis involves the sale of a commercial property where the basic structure is complete, including walls, floors, ceilings, and basic utilities, but the final interior finishes (such as flooring, fixtures, and customizations) need to be added by the buyer.' },
    { iconName: 'asset', iconPath: "assets/maps/legend/asset.png", text: 'ASSET SALE\nThis sale includes land and any finished buildings along with equipment and fixtures but excludes any business operations. The transaction focuses on physical assets only, without the transfer of the ongoing business or goodwill.' },
    { iconName: 'sync_alt', iconPath: "assets/maps/legend/goingconcern.png", text: 'GOING CONCERN/TURNKEY\nThis involves the sale of both the commercial property and the operating business, allowing the buyer to continue running the business seamlessly. "Turnkey" emphasizes that the business is ready for immediate operation.' },
    { iconName: 'check_circle', iconPath: "assets/maps/legend/approved.png", text: 'APPROVED RIGHTS\nA property with fully authorised planning permissions from the relevant municipality. The property is ready for construction or development in accordance with the granted rights.' },
    { iconName: 'schedule', iconPath: "assets/maps/legend/pending.png", text: 'PENDING RIGHTS\nPlanning permissions or approvals have been applied for but are still under review by the appropriate authorities. Development or construction on the property is contingent upon receiving the necessary permissions.' },
    { iconName: 'lightbulb', iconPath: "assets/maps/legend/potential.png", text: 'POTENTIAL RIGHTS\nThe property is currently not zoned for a specific type of development but has the possibility of securing planning rights in the future. There is a reasonable opportunity for the property to obtain the necessary approvals.' }
  ];

  statusIconMap: Record<string, string> = {
    'Unfinished structures': 'construction',
    'Expansion opportunity': 'expand',
    'White box': 'whitebox',
    'Asset sale': 'asset',
    'Going concern': 'sync_alt',
    'Approved rights': 'lightbulb',
    'Pending rights': 'schedule',
    'Potential rights': 'check_circle'
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sectorType'] && this.sectorType) {
      this.getAdvertTypes();
    }
    if (changes['advertCreatorFiltersDto'] && this.advertCreatorFiltersDto?.advertSector?.length) {
      this.hideShowPublishedItem();
    }
  }

  constructor(
    private advertService: AdvertService,
    private userManagementService: UserManagementService,
    private propertyListingService: PropertyListingService,
    private listingStateService: ListingStateService,
    private fileManagementService: FileManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.listingType = params['listingType'];
    });
    this.getCurrentUser();
    this.hideShowPublishedItem();
    //this.getAdvertTypes();

    // if (this.selectedListing) {
    //   console.log('selectedListing : ', this.selectedListing);
    //   console.log('selectedListingGroup : ', this.selectedListingGroup);
    // }
  }



  collapseOrExpandSection(section: { checked: boolean; }) {
    section.checked = !section.checked;
  }

  getDevelopedAdvert(): void {
    this.loading = true;
    this.advertService.apiV1AdvertGetAdvertReportDevelopedDataWithListingIdGet({ propertyListingId: this.selectedListing.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the advert developed data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: any | void) => {
        if (result.success) {
          this.advertGeneratorDeveloped = result.data;
          if (this.advertGeneratorDeveloped) {
            this.getFileURLWithFileId(this.advertGeneratorDeveloped.propertyImageFileId, "developed");
          }
          if (this.advertGeneratorDeveloped?.advertGenerateStatusses) {
            this.setAdvertIconsFromAdvert(
              this.advertGeneratorDeveloped.advertGenerateStatusses,
              'developed'
            );
          }
        } else {
          this.advertGeneratorDeveloped = null;
          this.notificationService.showErrorMessage("Error", "Could not get the advert developed data.");
        }
      });
  }

  async getDevelopableAdvert(): Promise<void> {
    this.loading = true;
    this.advertService.apiV1AdvertGetAdvertReportDevelopAbleDataWithListingIdGet({ propertyListingId: this.selectedListing.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the advert develop-able data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: any | void) => {
        if (result.success) {
          this.advertGeneratorDevelopable = result.data;
          if (this.advertGeneratorDevelopable) {
            this.getFileURLWithFileId(this.advertGeneratorDevelopable.propertyImageFileId, "developable");
          }
          if (this.advertGeneratorDevelopable?.advertGenerateStatusses) {
            this.setAdvertIconsFromAdvert(
              this.advertGeneratorDevelopable.advertGenerateStatusses,
              'developable'
            );
          }
        } else {
          this.advertGeneratorDevelopable = null;
          this.notificationService.showErrorMessage("Error", "Could not get the advert develop-able data.");
        }
      });
  }

  saveAdvertAppointed() {
    this.setPropertyListingTask();
  }

  setPropertyListingTask(): void {
    const changedTaskLists = this.selectedListing?.taskList
      ?.filter(task =>
        (task.taskNumber?.number === 11 && task.taskStatus?.taskStatusNumber !== 3) ||
        (task.taskNumber?.number === 12 && task.taskStatus?.taskStatusNumber === 1)
      )
      .map(task => {
        task.user = this.currentUser;
        return task;
      }) ?? [];

    if (changedTaskLists.length > 0) {
      this.propertyListingService.apiV1PropertyListingUpdatePropertyListingTaskPost({ body: changedTaskLists, currentTaskNumber: 11 }).subscribe(result => {
        if (result != null) {
          this.navigateToPlanningReport();
        }
        else {
          this.notificationService.showErrorMessage('Error', 'Failed to update planners.');
        }
      });
    }
    else {
      this.navigateToPlanningReport();
    }
  }

  getCurrentUser(): void {
    this.userManagementService.apiV1UserManagementGetCurrentUserGet().subscribe(result => {
      if (result != null) {
        this.currentUser = result;
      }
      else {
        this.notificationService.showWarningMessage('No Current User', 'No current user found.');
      }
    });
  }

  navigateToPlanningReport() {
    this.propertyListingService.apiV1PropertyListingGetPropertyListingByIdGet({ listingId: this.selectedListing?.id }).subscribe(result => {
      this.selectedListing = result;
      this.listingStateService.setSelectedListing(this.selectedListing);
      this.router.navigate(['admin/listings/listing-overview'], {
        queryParams: {
          listingType: this.listingType
        }
      });
    });
  }

  hideShowPublishedItem(): void {
    console.log("hideshow started");

    if (this.advertCreatorFiltersDto && this.advertCreatorFiltersDto.advertSector) {

      console.log("AdvertCreatorFiltersDto in hideShowPublishedItem:", this.advertCreatorFiltersDto);
      console.log("AdvertSector in hideShowPublishedItem:", this.advertCreatorFiltersDto.advertSector);

      this.advertCreatorFiltersDto?.advertSector?.forEach(element => {
        if (element.description === 'Developed') {
          this.showDevelopedOnly = true;
          this.showDevelopAbleOnly = false;
          if (this.selectedListing?.id) {
            this.getDevelopedAdvert();
          }
        } else if (element.description === 'Developable') {
          this.showDevelopedOnly = false;
          this.showDevelopAbleOnly = true;
          if (this.selectedListing?.id) {
            this.getDevelopableAdvert();
          }
        } else if (element.description === 'Both') {
          this.showDevelopedOnly = true;
          this.showDevelopAbleOnly = true;
          if (this.selectedListing?.id) {
            this.getDevelopedAdvert();
            this.getDevelopableAdvert();
          }
        }
      });
    } else {
      this.notificationService.showErrorMessage("Error", "The panels can not be hidden according to the filter saved for advert because advertCreatorFiltersDto is empty.");
    }
  }

  private getFileURLWithFileId(fileId: string, fileType: string): void {
    this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: fileId })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the advert develop-able data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: any | void) => {
        if (result) {
          const cleanUrl = result?.split('?')[0] ?? result;
          if (fileType == "developable") {
            this.developableImageFileUrl = cleanUrl;
          } else if (fileType == "developed") {
            this.developedImageFileUrl = cleanUrl;
          } else {
            this.notificationService.showWarningMessage("Warning", "Could not set any property listing images.");
          }
        } else {
          if (fileType == "developable") {
            this.notificationService.showErrorMessage("Error", "Could not get the Image URL for develop-able.");
          } else if (fileType == "developed") {
            this.notificationService.showErrorMessage("Error", "Could not get the Image URL for developed.");
          } else {
            this.notificationService.showErrorMessage("Error", "Could not get the Image URL.");
          }
        }
      });
  }

  private async getAdvertTypes() {
    try {
      let StatusList = await this.advertService.apiV1AdvertGetStatusDtOsGet().subscribe({
        next: (response: AdvertGenerateStatusDto[]) => {
          this.advertStatusList = response;
          debugger;
          if (this.sectorType) {
            this.advertStatusFilteredList = this.advertStatusList.filter(s => s.sectorType == this.sectorType)
          } else {
            this.notificationService.showWarningMessage('Warning', 'The sector type to filter the status is not defined and will not filter status. ');
          }
          this.advertStatusFilteredList = this.advertStatusList.filter(s => s.sectorType == this.sectorType);

          console.log("Filtered statuses:", this.advertStatusFilteredList);

          console.log('List', this.advertStatusList);
          console.log("sectorType input:", this.sectorType);

        },
        error: (_error: any) => {
          this.notificationService.showErrorMessage('Error', 'Could not load Advert types data.');
        }
      });
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "The file Id not found");
    }
    finally {
      this.loading = false;
    }
  }

  setAdvertIconsFromAdvert(statuses: AdvertGenerateStatusDto[], sector: string) {
    const icons: string[] = [];
    statuses
      .filter(status => this.statusIconMap[status.description])
      .slice(0, 2)
      .forEach(status => {
        const iconName = this.statusIconMap[status.description];
        icons.push(iconName);
      });
    if (sector === 'developed') {
      this.developedIcons = icons;
    }
    if (sector === 'developable') {
      this.developableIcons = icons;
    }
  }

}
